var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("transition", { attrs: { name: "slide" } }, [
    _vm.show
      ? _c(
          "div",
          {
            staticClass:
              "fixed-footer fixed bottom-0 left-0 right-0 zi-100 white-bkg ",
            class: _vm.footerClass
          },
          [_c("div", { staticClass: "p-2 px-5" }, [_vm._t("default")], 2)]
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }